import React from 'react';
import { motion, useMotionValue, useTransform } from 'framer-motion';

// Fancy animated checkbox as seen in stream chat polls
export default function CheckIndicator({ isChecked }) {
  const pathLength = useMotionValue(0);
  const opacity = useTransform(pathLength, [0.05, 0.15], [0, 1]);

  return (
    <>
      <motion.div
        style={{
          width: 30,
          height: 30,
          borderRadius: 15,
          backgroundColor: '#fff',
          cursor: 'pointer',
          position: 'absolute',
          left: 3,
          zIndex: 1,
        }}
        initial={{
          scale: 0,
          backgroundColor: 'rgba(100, 100, 100 , .2)',
        }}
        animate={{
          scale: isChecked ? 0.9 : 0.75,
          backgroundColor: isChecked ? 'rgba(100, 100, 100, .6)' : 'rgba(100, 100, 100 , .2)',
        }}
        transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      >
        <motion.svg xmlns="http://www.w3.org/2000/svg" width="30" height="30">
          <motion.path
            d="M7.6 14.90414l4.9294 4.9292L23.3 9.1"
            fill="transparent"
            strokeWidth="4"
            className={`checkmark_indicator`}
            strokeLinecap="round"
            initial={{ pathLength: isChecked ? 0.9 : 0 }}
            animate={{ pathLength: isChecked ? 0.9 : 0 }}
            style={{ pathLength: pathLength, opacity: opacity }}
          />
        </motion.svg>
      </motion.div>
    </>
  );
}
